import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { apiMethods } from '~/services/api';
import { apiMethodsConst } from '~/services/methods';

export interface IInviteProfessionalsToJobsPayload {
  jobIds: string[];
  professionalIds: string[];
  officeId?: string;
}

export function useInviteProfessionalsToJobsMutation() {
  return useMutation<unknown, AxiosError, IInviteProfessionalsToJobsPayload>({
    mutationFn: async ({ jobIds, professionalIds, officeId }) => {
      return await apiMethods[apiMethodsConst.INVITE_PROFESSIONALS_TO_JOBS_REQUEST]({
        jobIds,
        professionalIds,
        officeId,
      });
    },
  });
}
